var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    fill: "none",
    viewBox: "0 0 25 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.583,
    d: "M9.008 8.812c1.577 0 2.855-1.234 2.855-2.757 0-1.522-1.278-2.756-2.855-2.756S6.153 4.533 6.153 6.055c0 1.523 1.278 2.757 2.855 2.757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint0_linear_2492_172907)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.583,
    d: "M14.718 18H3.298v-1.225c0-1.462.602-2.864 1.673-3.898a5.81 5.81 0 0 1 4.037-1.615c1.515 0 2.967.58 4.038 1.615a5.42 5.42 0 0 1 1.672 3.898z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6161FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.583,
    d: "M14.082 3.299c.757 0 1.483.29 2.019.807a2.7 2.7 0 0 1 .836 1.95c0 .73-.301 1.431-.836 1.948a2.9 2.9 0 0 1-2.019.808M16.112 11.495a5.7 5.7 0 0 1 2.669 2.02 5.4 5.4 0 0 1 1.01 3.125V18H17.89"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2492_172907",
    x1: 5.107,
    x2: 8.823,
    y1: 12.395,
    y2: 18.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6CFF"
  })))));
};
export default SvgTeam;